export default __webpack_public_path__ + "static/media/crew-02-bit.a977db1d.svg";